import Endpoint from "../constants/Endpoint";
import HttpMethod from "../constants/HttpMethod";
import HttpHeaders from "../constants/HttpHeaders";

export const xhrPredictFromDateAndRequestHash = (
  date: string,
  requestHash: string
) => {
  var xhr = new XMLHttpRequest();
  xhr.open(
    HttpMethod.post,
    `https://${process.env.GATSBY_ROOT_API_URL}/${Endpoint.predict}`,
    true
  );
  xhr.setRequestHeader(HttpHeaders.date, date);
  xhr.setRequestHeader(HttpHeaders.authorization, requestHash);
  return xhr;
};
